import { useEffect } from "react";
import { connect } from "react-redux";
import Header from "./Header";
import Banner from "./Banner";
import Footer from "./Footer";
import RegisterSection from "./RegisterSection";
import OurStories from "./OurStories";
import About from "./About";
import WellWishers from "./WellWishers";
import JoinUs from "./JoinUs";
import ContactUs from "./ContactUs";
import Login from "./Login/index";
import { Container, Section } from "./Shared/ui";
import Seo from "./Shared/Seo";
import { showLoginModal } from "../store/actions";

//delete later once the search page is ready
import ProfileList from "./Profile/ProfileList";

const Home = (props) => {
  const { page = "home", showLoginModal } = props;

  // /login opens the login dialog, /register jumps to the sign-up form.
  useEffect(() => {
    if (page === "login") {
      showLoginModal();
    } else if (page === "register") {
      const frame = requestAnimationFrame(() => {
        document.getElementById("register")?.scrollIntoView();
      });
      return () => cancelAnimationFrame(frame);
    }
    return undefined;
  }, [page, showLoginModal]);

  return (
    <>
      <Seo page={page}/>
      <Header/>
      <main>
        <Banner/>
        { props.profiles &&
          <Section>
            <Container>
              <ProfileList/>
            </Container>
          </Section>
        }
        <RegisterSection/>
        <OurStories/>
        <About/>
        <WellWishers/>
        <JoinUs/>
        <ContactUs/>
      </main>
      <Footer/>
      { props.showLogin &&
        <Login/>
      }
    </>
  );
};

const mapStatetoProps = (state) => {
  return {
    user: state.userState.user,
    showLogin: state.userState.showLogin,
    profiles: state.profileState.searchResults,
  }
}

const mapDispatchToProps = (dispatch) => ({
  showLoginModal: () => dispatch(showLoginModal()),
});

export default connect(mapStatetoProps, mapDispatchToProps)(Home);
